"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSelectedPassengerId = void 0;
const react_1 = require("react");
const useSelectedPassengerId = (options) => {
    const { passengers } = options;
    const [selectedPassengerId, setSelectedPassengerId] = (0, react_1.useState)(options.selectedPassengerId);
    (0, react_1.useEffect)(() => {
        setSelectedPassengerId(options.selectedPassengerId);
    }, [options.selectedPassengerId]);
    const index = passengers.findIndex(x => x.id === selectedPassengerId);
    const nextSelectedPassengerId = () => {
        const newIndex = (index + 1) % passengers.length;
        setSelectedPassengerId(passengers[newIndex].id);
    };
    return {
        selectedPassengerId,
        nextSelectedPassengerId,
        setSelectedPassengerId,
    };
};
exports.useSelectedPassengerId = useSelectedPassengerId;
//# sourceMappingURL=useSelectedPassengerId.js.map